import APIClient from './index';
import _ from 'lodash';

export const updateUserTier = (userTier, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`UserTiers/${userTier.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
